import { Link } from "react-router-dom";
import { motion, useScroll, useTransform } from "framer-motion";
import { useRef } from "react";
import { ArrowUpRight } from "lucide-react";
import { MaskLine } from "../components/Reveal";
import Skyline from "../components/Skyline";

export default function HomeHero() {
  const heroRef = useRef(null);
  const { scrollYProgress } = useScroll({ target: heroRef, offset: ["start start", "end start"] });
  const skyY = useTransform(scrollYProgress, [0, 1], [0, 160]);
  const skyOpacity = useTransform(scrollYProgress, [0, 0.8], [1, 0]);
  const textY = useTransform(scrollYProgress, [0, 1], [0, -60]);

  return (
    <section ref={heroRef} className="relative min-h-screen flex flex-col justify-center overflow-hidden pt-24">
      <motion.div style={{ y: skyY, opacity: skyOpacity }} className="pointer-events-none absolute inset-x-0 top-[8%] flex justify-center">
        <Skyline className="w-[520px] max-w-[85vw] h-[52vh] opacity-[0.07]" />
      </motion.div>

      <motion.div style={{ y: textY }} className="relative max-w-[1400px] mx-auto px-6 md:px-10 w-full">
        <h1 className="font-display font-medium tracking-tighter leading-[0.92] text-[16vw] sm:text-[13vw] md:text-[9.5vw]">
          <MaskLine delay={0.15}>Close More.</MaskLine>
          <MaskLine delay={0.3} className="text-neutral-300">Chase Less.</MaskLine>
        </h1>

        <div className="mt-10 md:mt-14 grid md:grid-cols-12 gap-8 items-end">
          <motion.p className="md:col-span-6 lg:col-span-5 text-lg md:text-xl text-neutral-500 leading-relaxed" initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} transition={{ delay: 0.6, duration: 0.9, ease: [0.16, 1, 0.3, 1] }} data-testid="hero-subcopy">
            Quexify is your AI-augmented right hand, built with real estate expertise to run everything that isn't selling: transactions and closings, marketing and social, automations, admin, follow-ups and networking. So you can focus on growing your business.
          </motion.p>

          <motion.div className="md:col-span-6 lg:col-start-9 lg:col-span-4 flex flex-wrap gap-4 md:justify-end" initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} transition={{ delay: 0.75, duration: 0.9, ease: [0.16, 1, 0.3, 1] }}>
            <Link to="/book-demo" className="group inline-flex items-center gap-2 rounded-full bg-[#0a0a0a] text-white px-7 py-3.5 transition-transform duration-300 hover:-translate-y-0.5 hover:shadow-lg" data-testid="hero-book-demo">
              Book a discovery call <ArrowUpRight size={18} className="transition-transform duration-300 group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
            </Link>
            <Link to="/solutions" className="inline-flex items-center gap-2 rounded-full border border-neutral-300 px-7 py-3.5 transition-colors duration-300 hover:border-black" data-testid="hero-explore">
              See what we do
            </Link>
          </motion.div>
        </div>
      </motion.div>
    </section>
  );
}
